import { YardIssueTypeDummy } from '../models/yard-issue.model'

export type ResolutionActionType = 'createInternalMove'

export const getResolutionActions = (issueType: string): ResolutionActionType[] => {
  const issueTypesThatCanCreateInternalMove: ReadonlySet<string> = new Set([
    YardIssueTypeDummy.ReeferContainerInUnpoweredSlot,
    YardIssueTypeDummy.NonReeferContainerInReeferSlot,
    YardIssueTypeDummy.ImdgSegregationViolation,
    YardIssueTypeDummy.ImdgStackingOnTopViolation,
    YardIssueTypeDummy.ImdgTierCapViolation,
  ])

  if (issueTypesThatCanCreateInternalMove.has(issueType)) {
    return ['createInternalMove']
  }

  return []
}
